import React from "react";
import { FaBookReader } from "react-icons/fa";
import { motion } from "framer-motion";
import { COLORS } from "../constants/colors";

export default function Library() {
  return (
    <div
  className="flex flex-col items-center justify-center min-h-[80vh] text-center p-6"
  style={{
    backgroundColor: COLORS.background,
  }}
>
  <div
    style={{
      color: COLORS.textPrimary, 
    }}
  >
    <motion.div
      initial={{ opacity: 0, y: 40 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.8 }}
      className="max-w-lg"
    >
      <motion.div
        animate={{ rotate: [0, -5, 5, 0] }}
        transition={{ repeat: Infinity, duration: 3 }}
        className="mb-6 flex justify-center"
      >
        <FaBookReader size={80} color={COLORS.primary} />
      </motion.div>

      <h1 className="text-4xl font-bold mb-4">📚 Library Panel Coming Soon</h1>

      <p className="text-lg mb-8 text-gray-600">
        We’re building a smarter library experience — stay tuned!
      </p>

      <a
        href="#"
        style={{
          border: `2px solid ${COLORS.primary}`,
          color: COLORS.primary,
        }}
        className="px-10 py-4 rounded-xl font-semibold shadow-md hover:text-white hover:bg-sky-600 hover:scale-105 transition-all duration-300"
      >
        Notify Me
      </a>
    </motion.div>
  </div>
</div>

  );
}
